import './modal-campaign-finished.scss';
import ModalTemplate from '../modal-template/modal-template';
import ICON_MEDAL from '../../assets/icon-medal-campaign.png';
import MEDAL_GOLD from '../../assets/medal-gold.png';
import MEDAL_SILVER from '../../assets/medal-silver.png';
import MEDAL_BRONZE from '../../assets/medal-bronze.png';
import Button from '../button/button';
import UtilsService from '../../services/utils-service';
import TranslateService from '../../services/translate-service';


export default function ModalCampaignFinishedStatus(props) {


    return (
        <ModalTemplate isOpen={props.isOpen} className='modal-campaign-finished '>
            <div className='text-center'>
                <h1 className='heading-h6 !text-white'>{TranslateService.get('campaign.modal.finished.title')}</h1>
                <h1 className='heading-h5 !text-white mt-[8px]'>{props.data?.campania.nombre}</h1>
                
                { props.data?.jugador.posicion === 1 && <img src={MEDAL_GOLD} alt='' className='mx-auto mt-[24px] h-[60px]' />}
                { props.data?.jugador.posicion === 2 && <img src={MEDAL_SILVER} alt='' className='mx-auto mt-[24px] h-[60px]' />}
                { props.data?.jugador.posicion === 3 && <img src={MEDAL_BRONZE} alt='' className='mx-auto mt-[24px] h-[60px]' />}
                { props.data?.jugador.posicion > 3 && <img src={ICON_MEDAL} alt='' className='mx-auto mt-[24px] h-[60px]' />}

                {props.data && <h1 className='heading-h5 !text-white mt-[15px]'>{UtilsService.capitalize(props.data?.jugador.nombre, props.data?.jugador.apellidoPaterno)}</h1>}
                
                <p className='text-[#FFFBEF]'>{TranslateService.getAndReplace('campaign.modal.finished.position', { position: props.data?.jugador.posicion })}</p>


                <div className='card mt-[16px] !rounded-[20px] !p-[24px]'>

                    <div className='flex items-center'>
                        <p className='grow text-left'>{TranslateService.get('campaign.modal.finished.earned')}</p>
                        <p>{props.data?.jugador.puntos} pts</p>
                    </div>
                    <div className='flex items-center my-[8px]'>
                        <p className='grow text-left text-link-active'>{TranslateService.get('campaign.modal.finished.global')}</p>
                        <p className='text-link-active'>{props.data?.jugador.puntosAreas - props.data?.jugador.puntos} pts</p>
                    </div>
                    <div className='flex items-center'>
                        <p className='grow text-left'>{TranslateService.get('campaign.modal.finished.total')}</p>
                        <p>{props.data?.jugador.puntosAreas} pts</p>
                    </div>
                </div>


                <div className='mt-[56px]'>
                    <Button className='small' onClick={props.onClose}>
                    {TranslateService.get('campaign.modal.finished.btn')}
                    </Button>
                </div>

            </div>
        </ModalTemplate>
    )
}